import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import '@wdpr/button';
import { ModalService } from 'src/app/services/modal.service';
import { SessionTimeoutModalService } from 'src/app/services/session-timeout-modal.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
    selector: 'app-session-timeout-modal',
    templateUrl: './session-timeout-modal.component.html',
    styleUrls: ['./session-timeout-modal.component.scss'],
    standalone: false
})
export class SessionTimeoutModalComponent implements AfterViewInit, OnDestroy {

  constructor(public authService:AuthService,
		public languageService:LanguageService,
		private sessionTimeoutModal:SessionTimeoutModalService,
		private modalService:ModalService) { }

  ngAfterViewInit(): void {
    this.modalService.initModal('session-timeout-modal');
		this.modalService.addEventListener(
			'session-timeout-modal',
			'hidden.bs.modal',
			() => this.sessionTimeoutModal.setIsOpen(false)
		);
  }

	ngOnDestroy(): void {
		this.modalService.disposeModal('session-timeout-modal');
	}

}
